import * as React from "react";
import cx from "classnames";

import Suggestions from "./Suggestions";
import "./SearchInput.css";

export interface SearchInputProps {
  value: string;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  showSuggestions: boolean;
  className?: string;
  disableDropdown?: boolean;
  children?: JSX.Element[] | JSX.Element;
}

// TODO: That input[id] is used for styling
const SearchInput = (props: SearchInputProps) =>
  <div className={cx("search-price", props.className)}>
    <span className="search-price__icon">
      <i className="fa fa-search fa-flip-horizontal fa-2x" />
    </span>
    <input
      className="search-price__input"
      type="search"
      placeholder="standee, name card, logo, book cover..."
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      value={props.value}
    />
    {!props.disableDropdown &&
      <Suggestions shown={props.showSuggestions}>
        {props.children}
      </Suggestions>}
  </div>;

export default SearchInput;



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/components/SearchInput.tsx